// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// `ng build --env=stage` then `environment.stage.ts` will be used instead.
// `ng build --env=demo` then `environment.demo.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  host: window["env"]?.API_URL || location.hostname || 'localhost',
  socket: window["env"]?.SOCKET_URL || window["env"]?.API_URL || location.hostname || 'localhost',

  port: window["env"]?.PORT || (location.hostname === 'localhost' ? '8080': ''),

  protocol: window["env"]?.PROTOCOL
    || (location.hostname === 'localhost' ? 'http' : 'https'),

  // apiBaseUrl: '', // will build dynamically

  stripe: {
    publicKey: "pk_test_51PLHHNSDuguvJYJa9K8NaQ05NCohHREKIYV00wjG7xFfVYkbYAbajWRcHxmq5mkEJKCVcfBzRhm9RDiVInIm5W9D00psJWj24u"
  }
};
